import AnswerBlank from './AnswerBlank';
import WorksheetQuestions from './WorksheetQuestions';
import { WORKSHEET_CLASSES } from '../../constants/classNames';
import { getSiteEngine } from '../../data/sitePages';

/**
 * Compare lithium, sodium and potassium in water, then spot the pattern.
 */
export default function AlkaliMetalsSheet({ worksheet, showAnswers }) {
  const engine = getSiteEngine();
  const metals = worksheet.metals.map((id) => engine.getSubstance(id));

  return (
    <>
      <section className={WORKSHEET_CLASSES.part}>
        <h2 className={WORKSHEET_CLASSES.partTitle}>What did you see?</h2>
        <table className={WORKSHEET_CLASSES.table}>
          <thead>
            <tr>
              <th scope="col">In water</th>
              {metals.map((metal) => (
                <th key={metal.id} scope="col">
                  {metal.name} ({metal.symbol})
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {worksheet.tableRows.map(({ label, answers }) => (
              <tr key={label}>
                <th scope="row">{label}</th>
                {metals.map((metal) => (
                  <td key={metal.id}>
                    <AnswerBlank answer={answers[metal.id]} showAnswer={showAnswers} />
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </section>
      <WorksheetQuestions questions={worksheet.questions} showAnswers={showAnswers} />
    </>
  );
}
